import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import Header from '../../componets/header';
import HeaderMobile from '../../componets/header/mobile';
import Home from '../../blocks/home';
import HomeMobile from '../../blocks/home/mobile';
import About from '../../blocks/about';
import Timeline from '../../blocks/timeline';
import Product from '../../blocks/products';
import Counter from '../../blocks/counter';
import Blog from '../../blocks/blog';
import Testimunials from '../../blocks/testimunials';
import Cases from '../../blocks/cases';
import Contact from '../../blocks/contact';
import Footer from '../../componets/footer';


class OnePage extends Component {
    renderContent = () => {
        if (isMobile) {
            return (
                <main>
                    <HeaderMobile/>
                    <HomeMobile/>
                    <About/>
                    <Product/>
                    <Counter/>
                    {/* <Blog/> */}
                    {/* <Testimunials/> */}
                    <Cases/>
                    <Contact/>
                    <Footer/>
                </main>
            )
        }
        return (
            <main>
                <Header/>
                <Home/>
                <About/>
                <Timeline/>
                <Product/>
                <Counter/>
                {/* <Blog/> */}
                {/* <Testimunials/> */}
                <Cases/>
                <Contact/>
                <Footer/>
            </main>
        )
    }    
    render() {
        return this.renderContent();
    }    
}

export default OnePage